import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch } from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
	selectT0Limits: "selectT0Limits [Action]",
	selectT0LimitsLoading: "selectT0LimitsLoading [Action]",
	selectT0LimitsAsync: "selectT0LimitsAsync [Action]",
};
const inistiaState = {
	data: [],
	loading: false,
};

export const selectT0LimitsReducer = (
	state = inistiaState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectT0Limits:
			return {
				...state,
				data: payload,
			};
		case actionTypes.selectT0LimitsLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	//responseData.data.response.error_code
	yield put({
		type: actionTypes.selectT0LimitsLoading,
		payload: true,
	});

	let config = {
		url: "select_request",
	};

	let data = {
		table: "payment",
		method_type: "select_t0_limits",
		data: payload?.data ? payload.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		// let isOk = handleNotificationAlertTrySelect(res);
		// if (!isOk) {
		// 	return;
		// }
		yield put({
			type: actionTypes.selectT0Limits,
			payload: res?.data?.response,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({
			type: actionTypes.selectT0LimitsLoading,
			payload: false,
		});
	}
}

export function* selectT0Limits() {
	yield takeLatest(actionTypes.selectT0LimitsAsync, handleWorker);
}
